import axios from "axios";

import { baseUrl } from "./baseUrl";
import { uploadImage, updateImage } from './imageApiV2';

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Tips AIPs
export const createTip = async (data) => {
    try {
        const res = await api.post("/tips/add-tip", data);
        return res.data;
    } catch (error) {
        console.error("Error creating tip:", error);
        throw error;
    }
}

export const getTipsList = async () => {
    try {
        const res = await api.get("/tips/tip-list");
        return res.data;
    } catch (error) {
        console.error("Error fetching tips list:", error);
        throw error;
    }
}

export const getTipById = async (id) => {
    try {
        const res = await api.get(`/tips/view-tip/${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error fetching tip with ID ${id}:`, error);
        throw error;
    }
}

export const updateTip = async (data) => {
    try {
        const res = await api.put(`/tips/update-tip`, data);
        return res.data;
    } catch (error) {
        console.error(`Error updating tip `, error);
        throw error;
    }
}

export const deleteTip = async (id) => {
    try {
        const res = await api.delete(`/tips/delete-tip?id=${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error deleting tip with ID ${id}:`, error);
        throw error;
    }
}

// News AIPs

export const createNews = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading news cover image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'other', false);

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;

            console.log('✅ News cover image uploaded:', imageResult);
        }

        const res = await api.post("/news/add-news", data);
        return res.data;
    } catch (error) {
        console.error("Error creating news:", error);
        throw error;
    }
}

export const getNewsList = async () => {
    try {
        const res = await api.get("/news/news-list");
        return res.data;
    } catch (error) {
        console.error("Error fetching news list:", error);
        throw error;
    }
}

export const getNewsById = async (id) => {
    try {
        const res = await api.get(`/news/view-news/${id}`);
        console.log(res.data);
        return res.data;
    } catch (error) {
        console.error(`Error fetching news with ID ${id}:`, error);
        throw error;
    }
}

export const updateNews = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading news cover image to Image API V2...');

            // Use updateImage if fileId exists, otherwise upload new
            let imageResult;
            if (data.fileId) {
                imageResult = await updateImage(data.fileId, data.file);
                console.log('✅ News cover image updated to version:', imageResult.version);
            } else {
                imageResult = await uploadImage(data.file, 'other', false);
                console.log('✅ News cover image uploaded:', imageResult);
            }

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;
        }

        const res = await api.put(`/news/update-news`, data);
        return res.data;
    } catch (error) {
        console.error(`Error updating news `, error);
        throw error;
    }
}

export const deleteNews = async (id) => {
    try {
        const res = await api.delete(`/news/delete-news?id=${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error deleting news with ID ${id}:`, error);
        throw error;
    }
}
// Videos AIPs

export const createVideo = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading video cover image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'other', false);

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;

            console.log('✅ Video cover image uploaded:', imageResult);
        }

        const res = await api.post("/video/add-video", data);
        return res.data;
    } catch (error) {
        console.error("Error creating video:", error);
        throw error;
    }
}

export const getVideoList = async () => {
    try {
        const res = await api.get("/video/video-list");
        return res.data;
    } catch (error) {
        console.error("Error fetching video list:", error);
        throw error;
    }
}

export const getVideoById = async (id) => {
    try {
        const res = await api.get(`/video/view-video/${id}`);
        console.log(res.data);
        return res.data;
    } catch (error) {
        console.error(`Error fetching video with ID ${id}:`, error);
        throw error;
    }
}

export const updateVideo = async (data) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading video cover image to Image API V2...');

            // Use updateImage if fileId exists, otherwise upload new
            let imageResult;
            if (data.fileId) {
                imageResult = await updateImage(data.fileId, data.file);
                console.log('✅ Video cover image updated to version:', imageResult.version);
            } else {
                imageResult = await uploadImage(data.file, 'other', false);
                console.log('✅ Video cover image uploaded:', imageResult);
            }

            data.fileId = imageResult.imageId;
            data.fileVersion = imageResult.version;
            data.file = imageResult.url;
        }

        const res = await api.put(`/video/update-video`, data);
        return res.data;
    } catch (error) {
        console.error(`Error updating video `, error);
        throw error;
    }
}

export const deleteVideo = async (id) => {
    try {
        const res = await api.delete(`/video/delete-video?id=${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error deleting video with ID ${id}:`, error);
        throw error;
    }
}